export const FRONTEND_URL = process.env.VUE_APP_FRONTEND_URL
export const API_URL = process.env.VUE_APP_API_URL

export const ROLE_USER = "user"
export const ROLE_MANAGER = "manager"
export const ROLE_ADMIN = "admin"
export const ROLE_MAESTRO = "maestro"

export const I18N_USER_ROLES = {
  [ROLE_MAESTRO]: "Маэстро",
  [ROLE_ADMIN]: "Администратор",
  [ROLE_MANAGER]: "Управляющий",
  [ROLE_USER]: "Пользователь"
}

export const ROLE_SCORE_MAP = {
  [ROLE_MAESTRO]: 4,
  [ROLE_ADMIN]: 3,
  [ROLE_MANAGER]: 2,
  [ROLE_USER]: 1
}

export const INTEGRATION_COMPASS = "compass"
export const INTEGRATION_TELEGRAM = "telegram"

export const INTEGRATIONS = [INTEGRATION_COMPASS, INTEGRATION_TELEGRAM]
export const NOTIFICATION_INTEGRATIONS = [INTEGRATION_COMPASS, INTEGRATION_TELEGRAM]
export const INTEGRATION_PIC_MAP = {
  [INTEGRATION_COMPASS]: new URL(`@/assets/pictures/integrations/compass.png`, import.meta.url).href,
  [INTEGRATION_TELEGRAM]: new URL(`@/assets/pictures/integrations/telegram.png`, import.meta.url).href,
}

export const SCHEDULE_HOURS_MODE = "hours"
export const SCHEDULE_EMPLOYMENT_MODE = "employment"


export const SCHEDULE_LIMIT_TRANSLATION = {
  week: "неделю",
  month: "месяц",
  year: "год"
}

// Системный статус / детект техработ (см. systemModule)
export const SYSTEM_STATUS_POLL_INTERVAL = 15000
export const SYSTEM_STATUS_FAIL_THRESHOLD = 2

export const SYSTEM_STATUS_AVAILABLE = "available"
export const SYSTEM_STATUS_MAINTENANCE = "maintenance"
export const SYSTEM_STATUS_UNAVAILABLE = "unavailable"